<template>
  <el-dialog
    title=""
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <div style="height: 220px">
      <el-input
        type="textarea"
        :rows="6"
        placeholder="请输入内容"
        v-model="textarea"
      >
      </el-input>
      <div style="display: flex; justify-content: center; padding: 20px">
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { createLeaveMessage } from "@/api/moudles/user";
export default {
  data() {
    return {
      dialogVisible: false,
      textarea: "",
      dialogWidth: "30%",
    };
  },
  mounted() {
    console.log(this.$phoneSize());
    if (this.$phoneSize()) {
      this.dialogWidth = "95%";
    } else {
      this.dialogWidth = "30%";
    }
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },
    submit() {
      if (this.textarea.trim() === "") {
        this.$message.error("请填写内容");
        return;
      }
      createLeaveMessage({
        data: {
          memberCode: this.$store.state.user.userInfo.memberCode,
          realName: this.$store.state.user.userInfo.realName,
          question: this.textarea,
        },
        success: () => {
          this.$message.success("提交成功");
          this.dialogVisible = false;
          this.textarea = "";
          this.$emit("refresh");
        },
        error: () => {
          this.$message.error("提交失败");
        },
      });
    },
    handleClose() {
      this.textarea = "";
      this.dialogVisible = false;
    },
  },
};
</script>
